import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'

import InfoIcon from '@components/Icon/Info'
import CancelIcon from '@components/Icon/Cancel'
import CheckCircledIcon from '@components/Icon/CheckCircled'
import WarningIcon from '@components/Icon/Warning'
import CloseIcon from '@components/Icon/Close'

import './Growl.sass'

/*
Call like this:

this.props.growlStore.addNotification({
  title: 'Some title'
  message: 'You have successfully changed status Lorem ipsum dolor sit amet',
  type: 'success', // default white bkg with black text / icons
  callback: this.myCallback,
  timeout: 4000, // default 6000
  autoClose: true, // default false
  children: <html>
});

- icon, message, title are default props, you can replace
them with your html (children prop)

*/

class Growl extends Component {
  renderNotifications = () => {
    const { growlStore } = this.props
    return growlStore.list.map(notification => {
      // set type and animation
      let className = 'notification-wrapper__single'

      if (notification.autoClose) {
        className += ' notification-wrapper__single__animation--autoclose'
      }

      if (notification.type) {
        className += ' notification-wrapper__single--' + notification.type
      }

      // check if children is prop
      if (notification.children) {
        return this.renderChildren(notification, className)
      }

      return (
        <div key={notification.id} className={className}>
          {this.renderIcon(notification)}
          <div className='notification-wrapper__single__box'>
            {this.renderTitle(notification)}
            {this.renderMessage(notification)}
            {this.renderCloseButton(notification.id)}
          </div>
        </div>
      )
    })
  }

  handleBoxClick = notification => {
    if (notification.callback) notification.callback()
    if (notification.linkTo) this.props.history.push(notification.linkTo)
    this.props.growlStore.removeNotification(notification.id)
  }

  renderIcon = notification => {
    let icon = <InfoIcon />
    if (notification.type === 'success') icon = <CheckCircledIcon />
    if (notification.type === 'error') icon = <CancelIcon />
    if (notification.type === 'warning') icon = <WarningIcon />
    if (notification.type === 'notice') icon = <WarningIcon />

    return <div className='notification-wrapper__single__icon'>{icon}</div>
  }

  renderCloseButton = id => {
    return (
      <button
        className='notification-wrapper__single__close'
        onClick={() => this.props.growlStore.removeNotification(id)}
      >
        <CloseIcon />
      </button>
    )
  }

  renderTitle = notification => {
    if (!notification.title) return null
    return (
      <span
        className='notification-wrapper__single__title'
        dangerouslySetInnerHTML={{ __html: notification.title }}
      />
    )
  }

  renderMessage = notification => {
    if (!notification.message) return null
    return (
      <span
        className='notification-wrapper__single__message'
        dangerouslySetInnerHTML={{ __html: notification.message }}
        onClick={() => this.handleBoxClick(notification)}
      />
    )
  }

  renderChildren = (notification, className) => {
    return (
      <div className={className} onClick={this.handleBoxClick(notification)}>
        <div dangerouslySetInnerHTML={{ __html: notification.children }} />
      </div>
    )
  }

  render () {
    return (
      <div className='notification-wrapper'>{this.renderNotifications()}</div>
    )
  }
}

Growl.propTypes = {
  growlStore: PropTypes.object,
  history: PropTypes.object
}

export default withRouter(inject('growlStore')(observer(Growl)))
